import { NavLink, useParams } from "react-router";
import {
  WorkOrderTable,
  WorkOrderTableFilters,
} from "@/services/backend/htz/work-order/components/work-orders-table";
import { useState } from "react";
import { ListRequest } from "@/services/backend/htz/work-order/api/work-order-api";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";
import { DocumentLink } from "@/routes/_components/links/document-link";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import t from "@/lang/lang";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { HtzBreadcrumbs } from "@/routes/processes/[processId]/htz/_components/htz-breadcrumbs";

export function WorkOrdersCompletionRoute() {
  const { processId } = useParams();
  const [request, setRequest] = useState<ListRequest>({
    process: {
      active: true,
      values: [processId!],
    },
    workOrderState: {
      active: true,
      values: [
        FulfillmentState.Executed,
        FulfillmentState.PartiallyExecuted,
        FulfillmentState.Cancelled,
        FulfillmentState.Completed,
      ],
    },
    orderBy: [{ field: "beginDate", dsc: true }],
    limit: 10,
    offset: 0,
  });

  const { data: process } = useProcessesProcessShowQuery({ id: processId! });

  if (!process) return null;

  const breadcrumbs = (
    <HtzBreadcrumbs customerId={process.customerId} processId={process.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem className="hidden md:block">
        <BreadcrumbLink asChild>
          <NavLink to={`/processes/htz/${process.id}/work-orders`}>
            {t("Arbeitsscheine")}
          </NavLink>
        </BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Nachbereitung")}</BreadcrumbPage>
      </BreadcrumbItem>
    </HtzBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <div className="grid gap-2">
        <WorkOrderTableFilters request={request} onRequestChange={setRequest} />
        <WorkOrderTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={(id, pid, kind) => (
            <DocumentLink
              documentId={id}
              documentKind={kind}
              serviceKind={GSMServiceKind.HTZ}
              processId={pid}
            />
          )}
        />
      </div>
    </ProcessPageMainTemplate>
  );
}
